'use client';

import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { IconWrapper } from '../ui/icon-wrapper';
import LogoIcon from '/public/logo.svg';

export function Logo() {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // After mount, we can access the theme
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="flex h-6 w-6 items-center justify-center flex-shrink-0">
      <IconWrapper icon={LogoIcon} size={24} />
    </div>
  );
}
